<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialogEntry"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      :before-close="resetValidation('entry')"
      @close="setDialogEntry(false)"
    >
      <el-form ref="entry" :model="entry" label-position="top">
        <el-form-item label="Title" prop="title" required>
          <el-input type="text" v-model="entry.title" clearable />
        </el-form-item>
        <div>
          <p class="inline-eye">Text</p>
          <i class="el-icon-view ml10" @click="openPreview(entry.text)"></i>
        </div>
        <el-form-item prop="text">
          <vue-editor v-model="entry.text" :editorToolbar="customToolbar" />
        </el-form-item>
        <el-form-item label="Position" prop="position" required>
          <el-input type="number" v-model="entry.position" clearable />
        </el-form-item>
        <el-form-item
          label="Category"
          prop="category_id"
          :rules="[{ required: true, message: 'category is required' }]"
        >
          <el-select
            v-model="entry.category_id"
            clearable
            filterable
            class="mr10"
          >
            <el-option
              v-for="a in categories.data"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },

  data() {
    return {
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      text: ''
    }
  },

  computed: {
    dialogTitle() {
      if (typeof this.entry.id !== 'undefined' && this.entry.id !== null) {
        return 'Edit Entry'
      } else {
        return 'Insert Entry'
      }
    },
    ...mapState('faq', ['loading', 'entry', 'categories', 'dialogEntry'])
  },

  methods: {
    ...mapActions('faq', ['updateEntry', 'insertEntry']),
    ...mapMutations('faq', ['setSelectedEntry', 'setDialogEntry']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      if (typeof this.entry.id !== 'undefined' && this.entry.id !== null) {
        this.updateEntry(this.entry.id)
      } else {
        this.insertEntry()
      }
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    resetValidation(formName) {
      if (typeof this.$refs[formName] != 'undefined') {
        this.$refs[formName].fields.find(f => f.prop == 'title').clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'position')
          .clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'category_id')
          .clearValidate()
      }
    }
  }
}
</script>

<style scoped>
.inline-eye {
  display: inline-block;
}
</style>
